// extracted by mini-css-extract-plugin
export default {"profileSection":"style_profileSection__oczSx","header":"style_header__FzhHP","content":"style_content__WYXvn","boxProfile":"style_boxProfile__H0YmK","website":"style_website__Loi9B"};